module.exports = __webpack_public_path__ + "static/img_reward_utbracelet@2x-d4bab0108b30091e79865348eb485102.png";